import styled from 'styled-components';
import { IOpenMarketProduct } from '../../../interfaces/OpenMarketProduct.interfaces';
import { SwiperItemContainer } from '../../../components/common/itemContainer/SwiperItemContainer';
import { OpenMarketProductPreviewCardPageType } from './OpenMarketProductPreviewCard/OpenMarketProductPreviewCard';
import { GoToListPageButton } from '../../../components/common/buttons/GoToListPageButton';
import { Image } from 'antd';
import { Chip } from '../../../components/common/chip/Chip';
import { ampli } from '../../../ampli';

interface OpenMarketImageOnlySwiperProps {
  openMarketProducts: IOpenMarketProduct[];
  pageType: OpenMarketProductPreviewCardPageType;
}

const SLIDE_WIDTH = 300;
const SLIDE_HEIGHT = 255;

export const OpenMarketImageOnlySwiper = ({ openMarketProducts, pageType }: OpenMarketImageOnlySwiperProps) => {
  if (openMarketProducts.length > 1) {
    return (
      <Wrapper id={'open-market-product-swiper-container'}>
        <SwiperItemContainer
          slideItemWidth={SLIDE_WIDTH}
          slideItems={openMarketProducts.map((openMarketProduct) => (
            <Image.PreviewGroup
              key={openMarketProduct.id}
              items={openMarketProduct.images
                .sort((a, b) => {
                  if (a.type === 'LEFT') return -1;
                  if (b.type === 'LEFT') return 1;
                  return 0;
                })
                .map((image) => image.imageUrl)}
              preview={{
                toolbarRender: () => null,
              }}
            >
              <CustomImage
                key={openMarketProduct.images.find((image) => image.type === 'LEFT')?.imageUrl}
                src={openMarketProduct.images.find((image) => image.type === 'LEFT')?.imageUrl}
                alt={openMarketProduct.images.find((image) => image.type === 'LEFT')?.imageUrl}
                style={{
                  minWidth: '300px',
                  width: '300px',
                  height: '255px',
                  left: '0',
                  right: '0',
                  objectFit: 'cover',
                }}
                preview={{
                  mask: '',
                }}
                onClick={() =>
                  ampli.pvmClickRealSellingModelOnMarketPrice({
                    brand: openMarketProduct.machine.brand.name,
                    model: openMarketProduct.machine.model,
                    hp: openMarketProduct.machine.engineOutputInPs,
                    selling_price: openMarketProduct.hopeSellingPrice,
                  })
                }
              />
              {openMarketProduct.status === 'ONSALE' && (
                <span style={{ position: 'absolute', top: 8, left: 8 }}>
                  <Chip type={'square'} theme={'strong'} color={'primary'} size={'lg'}>
                    {'판매 중인 매물'}
                  </Chip>
                </span>
              )}
            </Image.PreviewGroup>
          ))}
          extraElement={{
            width: 150,
            element: <GoToListPageButton renderedIn={'odp'} itemType={'open-market'} height={SLIDE_HEIGHT} />,
          }}
        />
      </Wrapper>
    );
  }

  if (openMarketProducts.length === 1) {
    return (
      <Image.PreviewGroup
        key={openMarketProducts[0].id}
        items={openMarketProducts[0].images
          .sort((a, b) => {
            if (a.type === 'LEFT') return -1;
            if (b.type === 'LEFT') return 1;
            return 0;
          })
          .map((image) => image.imageUrl)}
        preview={{
          toolbarRender: () => null,
        }}
      >
        <CustomImage
          key={openMarketProducts[0].images.find((image) => image.type === 'LEFT')?.imageUrl}
          src={openMarketProducts[0].images.find((image) => image.type === 'LEFT')?.imageUrl}
          alt={openMarketProducts[0].images.find((image) => image.type === 'LEFT')?.imageUrl}
          style={{
            minWidth: '100%',
            width: '100%',
            height: '100%',
            left: '0',
            right: '0',
            objectFit: 'cover',
          }}
          preview={{
            mask: '',
          }}
        />
        {openMarketProducts[0].status === 'ONSALE' && (
          <span style={{ position: 'absolute', top: 8, left: 8 }}>
            <Chip type={'square'} theme={'strong'} color={'primary'} size={'lg'}>
              {'판매 중인 매물'}
            </Chip>
          </span>
        )}
      </Image.PreviewGroup>
    );
  }

  return null;
};

const Wrapper = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;

  width: 100%;
`;

const CustomImage = styled(Image)`
  border-radius: 8px;
  background: var(--Light-Scheme-Monochrome-white, #fff);
`;
